import type { InputHTMLAttributes } from 'react'
import styles from './Switch.module.css'

export interface SwitchProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'size'> {
  label?: string
  size?: 'sm' | 'md'
}

export function Switch({ label, size = 'md', className, disabled, ...props }: SwitchProps) {
  const trackClasses = [
    styles.track,
    size === 'sm' && styles.sm,
    className,
  ].filter(Boolean).join(' ')

  const input = <input type="checkbox" role="switch" className={trackClasses} disabled={disabled} {...props} />

  if (!label) return input

  const labelClasses = [styles.label, disabled && styles.disabled].filter(Boolean).join(' ')
  return (
    <label className={labelClasses}>
      {input}
      {label}
    </label>
  )
}
